import plateLogoImg from "@assets/plate-os-logo-nobg.png";

interface PlateOSLogoProps {
  size?: number;
  className?: string;
}

export function PlateOSLogo({ size = 24, className = "" }: PlateOSLogoProps) {
  return (
    <img
      src={plateLogoImg}
      alt="Plate OS"
      width={size}
      height={size}
      className={`shrink-0 object-contain ${className}`}
      draggable={false}
    />
  );
}
